import type { ShapeType } from "@ng-org/shex-orm";
import { festipodShapesSchema } from "./festipodShapes.schema.ts";
import type {
  Event,
  UserProfile,
  Participation,
  MeetingPoint,
  Notification,
} from "./festipodShapes.typings.ts";

// ShapeTypes for festipodShapes
export const EventShapeType = {
  schema: festipodShapesSchema,
  shape: "http://festipod.org/Event",
} as const satisfies ShapeType<Event>;

export const UserProfileShapeType = {
  schema: festipodShapesSchema,
  shape: "http://festipod.org/UserProfile",
} as const satisfies ShapeType<UserProfile>;

export const ParticipationShapeType = {
  schema: festipodShapesSchema,
  shape: "http://festipod.org/Participation",
} as const satisfies ShapeType<Participation>;

export const MeetingPointShapeType = {
  schema: festipodShapesSchema,
  shape: "http://festipod.org/MeetingPoint",
} as const satisfies ShapeType<MeetingPoint>;

export const NotificationShapeType = {
  schema: festipodShapesSchema,
  shape: "http://festipod.org/Notification",
} as const satisfies ShapeType<Notification>;
